// if you need to add custom js put it in here      // Click events
$(function () {
    if ($('.section-description-non-hero').height() < 500) {
        $(this).removeClass('section-description-non-hero');
        $('.show-other-options-more-options').hide();
    }
    else {
        $('.section-description-non-hero').height("506");
    }
});